import { render } from "./RoluriDrepturiGrid.vue?vue&type=template&id=c098108e&scoped=true&ts=true"
import script from "./RoluriDrepturiGrid.vue?vue&type=script&lang=ts"
export * from "./RoluriDrepturiGrid.vue?vue&type=script&lang=ts"

import "./RoluriDrepturiGrid.vue?vue&type=style&index=0&id=c098108e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c098108e"]])

export default __exports__